import { render, staticRenderFns } from "./ViewTemplate.vue?vue&type=template&id=9a4e68f8&scoped=true&"
import script from "./ViewTemplate.vue?vue&type=script&lang=js&"
export * from "./ViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4e68f8",
  null
  
)

export default component.exports